module.exports = "/images/icon_48_leftchev.png?2969b00011f15076d3e13a3b3189f00d";